module.exports = __webpack_public_path__ + "resource/img/banner.jpg?0b1d9087f15971a2be72b967577864d7";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner.jpg
// module id = 442
// module chunks = 36